<template>
  <div>
    <v-data-table :headers="headers" :items="items" :pagination="pagination"
                  @update:pagination="updatePagination">
      <template slot="items" slot-scope="item">
        <td class="text-xs-left">{{ item.item.label }}</td>
        <td v-if="editable" class="buttonCell">
          <v-btn icon right @click="remove(item.item.value)">
            <v-icon color="error">delete</v-icon>
          </v-btn>
        </td>
      </template>
      <template slot="no-data">
        <div class="text-xs-center">
          No {{ name }}s
        </div>
      </template>
      <template slot="actions">
        <div v-if="editable" class="push-left">
          <v-subheader>
            Add {{ name }}
            <v-btn icon @click="openModal">
              <v-icon color="success">add_box</v-icon>
            </v-btn>
          </v-subheader>
        </div>
      </template>
    </v-data-table>
    <v-dialog v-model="showModal" max-width="500px">
      <v-card>
        <v-form @submit.prevent="add">
          <v-layout row wrap>
            <v-flex xs12 md4>
              <v-subheader>{{ capitalize(name) }}</v-subheader>
            </v-flex>
            <v-flex xs12 md8 class="inputContainer">
              <v-text-field v-if="selectType === 'freeform'" v-model="addItem"/>
              <option-search v-else-if="selectType === 'search'" v-model="searchAddItemLabel"
                             @select="searchSelect" :options="unselectedItemsSearch"
                             :minchars="searchMinchars" keypath="value" labelpath="label"/>
              <v-select v-else v-model="addItem" :items="unselectedItems" item-text="label"
                        item-value="value" :disabled="allItemsSelected"/>
            </v-flex>
          </v-layout>
          <v-btn @click="closeModal">Cancel</v-btn>
          <v-btn class="confirm" @click="add">Add</v-btn>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import OptionSearch from './OptionSearch';

  export default {
    components: { OptionSearch },
    props: {
      value: {},
      options: {},
      name: {},
      editable: { default: true },
      selectType: { default: 'dropdown' },
      searchMinchars: { default: 3 },
      pagination: { default: () => ({}) }
    },
    data() {
      return {
        headers: [{ text: this.capitalize(this.name), value: 'label' }],
        showModal: false,
        addItem: null,
        searchAddItem: null,
        searchAddItemLabel: ''
      };
    },
    computed: {
      items() {
        return (this.value || []).map((value) => {
          return {
            label: this.getLabel(value),
            value
          };
        });
      },
      structuredOptions() {
        return this.options.map((o) => {
          if (o.label && o.value) {
            return o;
          } else {
            return { label: o, value: o };
          }
        });
      },
      unselectedItemsSearch() {
        return this.structuredOptions
          .filter((o) => this.value.indexOf(o.value) === -1);
      },
      unselectedItems() {
        const items = this.structuredOptions.filter((o) => this.value.indexOf(o.value) === -1);

        return items.length ? items : [`No ${this.name}s remaining`];
      },
      allItemsSelected() {
        return !!this.options && this.value.length >= this.options.length;
      }
    },
    methods: {
      getLabel(value) {
        if (this.options) {
          const match = this.structuredOptions
            .filter((o) => o.value === value);
          return match.length ? match[0].label : value;
        } else {
          return value;
        }
      },
      capitalize(s) {
        if (s && s.length) {
          return s[0].toUpperCase() + s.substring(1);
        }

        return s;
      },
      openModal() {
        if (this.allItemsSelected) {
          this.addItem = this.unselectedItems[0];
        }
        this.showModal = true;
      },
      closeModal() {
        this.showModal = false;
        this.addItem = null;
      },
      searchSelect(val) {
        this.searchAddItem = val.value;
        this.searchAddItemLabel = val.label;
      },
      add() {
        let selectedItem;
        if (this.selectType === 'search') {
          selectedItem = this.searchAddItem;
          this.searchAddItem = null;
          this.searchAddItemLabel = '';
        } else {
          selectedItem = this.addItem;
        }
        if (!this.allItemsSelected && selectedItem != null) {
          this.$emit('input', this.value.concat(selectedItem));
        }
        this.closeModal();
      },
      remove(item) {
        this.$emit('input', this.value.filter((o) => item !== o));
      },
      updatePagination(e) {
        this.$emit('update:pagination', e);
      }
    }
  };
</script>

<style lang="less" scoped>
  .push-left {
    margin-right: auto;
  }

  .buttonCell {
    text-align: right;
  }

  .inputContainer {
    padding-left: 15px;
    padding-right: 15px;
  }
</style>
